// stores/useNotificationStore.js
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNotificationStore = defineStore('notification', () => {
  const notifiedVehicleIds = ref(new Set());

  const addNotifiedId = (id) => {
    notifiedVehicleIds.value.add(id);
    // Trigger reaktivitas Vue dengan reassign
    notifiedVehicleIds.value = new Set(notifiedVehicleIds.value);
  };

  const clearNotifiedId = (id) => {
    notifiedVehicleIds.value.delete(id);
    notifiedVehicleIds.value = new Set(notifiedVehicleIds.value);
  };

  const clearAll = () => {
    notifiedVehicleIds.value = new Set();
  };

  const hasId = (id) => notifiedVehicleIds.value.has(id);

  return {
    notifiedVehicleIds,
    addNotifiedId,
    clearNotifiedId,
    clearAll,
    hasId,
  };
});